import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';

const routes: Routes = [
  {
    path:'list' ,component:ListComponent
  },
  {
    path:'add' ,component:AddComponent
  },
  {
    path:'edit-main-menu/:id' ,component:AddComponent
  },
  {
    path:'edit-sub-menu/:id' ,component:AddComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ControlManagementRoutingModule { }
